import React from 'react';
import Hero from '../components/Hero';
import RegulatoryApprovals from '../components/RegulatoryApprovals';
import About from '../components/About';
import Quality from '../components/Quality';
import Products from '../components/Products';
import WhyUs from '../components/WhyUs';
import PageLoader from '../components/PageLoader';
import usePageLoader from '../hooks/PageLoader';

const HomePage = () => {


  return (
    <div>
      <Hero />
      <RegulatoryApprovals />
      <About />
      <Quality />
      <Products />
      <WhyUs />
    </div>
  );
};

export default HomePage;